import httpService from './httpService'
import SessionService from './sessionService'

async function getByProfileUsername() {
  return httpService.apiRequest('get', `/profile/${SessionService.getUserUsername()}/organizations`)
}

async function getById(organizationId) {
  return httpService.apiRequest('get', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}`)
}

async function add(data) {
  return httpService.apiRequest('post', `/profile/${SessionService.getUserUsername()}/organization`, data)
}

async function update(organizationId, data) {
  return httpService.apiRequest('patch', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}`, data)
}

async function remove(organizationId) {
  return httpService.apiRequest('delete', `/profile/${SessionService.getUserUsername()}/organization/${organizationId}`)
}

async function getOrganizationStatsForPeriod(organizationId, startTime, endTime) {
  const query = []
  if (startTime) query.push('startTime=' + startTime)
  if (endTime) query.push('endTime=' + endTime)
  const queryParams = query.length > 0 ? '?' + query.join('&') : ''
  return httpService.apiRequest('get', `/profile/${SessionService.getUserUsername()}/stats/organization/${organizationId}${queryParams}`)
}

export default {
  getByProfileUsername,
  getById,
  add,
  update,
  remove,
  getOrganizationStatsForPeriod
}



// WEBPACK FOOTER //
// ./src/services/organizationService.js